import axios from '@axios'

const PREFIX = '/parametrizacao-controle-vencimento'

export default {

  salvarControleVencimento(config) {
    return axios.put(`${PREFIX}/controle`, config)
  },

  getControleVencimento() {
    return axios.get(`${PREFIX}/controle`)
  },

  getDiasAVencer() {
    return axios.get(`${PREFIX}/dias-a-vencer`)
  },
}
